'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBlock } from './ErrorBlock';
import { Intercom, useIntercom } from '@/hooks/3dParty/intercom';

export const NotFoundBlock = () => {
  const { t } = useTranslation('common');

  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'notFound',
        pathToFile: 'src/components/internal/NotFound.tsx',
      });

      scope.setLevel('error');

      Sentry.captureMessage('Page not Found');
    });
  }, []);

  useIntercom();

  return (
    <ErrorBlock
      logo
      showUrl
      image="/common/notFoundImg.webp"
      text={t('errorsPages.notFound.text')}
      buttonText={t('errorsPages.notFound.buttonText')}
      handleOpenSupport={Intercom.openChat}
    />
  );
};
